import DocumentationElement from "./DocumentationElement"
import { ValueType } from "pokal_api"

export const VALUE_TYPE_PHQ_DOC: DocumentationElement = {
    title: "Patient Health Questionnaire (PHQ-8)",
    content:
        "Der PHQ-8 ist eine Kurzform des PHQ-9 und dient ebenfalls der Diagnose und dem Monitoring von Depressionen. Er besteht aus acht Fragen, die sich auf die Häufigkeit verschiedener depressiver Symptome in den letzten zwei Wochen beziehen. Der PHQ-8 ist sowohl als diagnostisches Instrument als auch als Maß für den Schweregrad von Depressionen geeignet."
}

export const VALUE_TYPE_SFQ_DOC: DocumentationElement = {
    title: "Sturz- und Symptomfragen (SFQ)",
    content:
        "Die Patient:in soll die vier Fragen zu Schwindel, Verstopfung, Sturz und sexueller Funktionsstörung alle zwei Wochen beantworten. Die Antworten werden in die Medikationsanalyse miteinbezogen. SFQ steht für Symptom and Fall Questions, Symptom- und Sturzfragen. Der SFQ ist kein quantifizierter Fragebogen. Es gibt keinen Score und keine Trendbewertung. Die Antworten dienen ausschließlich der qualitativen Einschätzung und Dokumentation."
}

const VALUE_TYPE_MOOD_DOC: DocumentationElement = {
    title: "Stimmungserfassung",
    content:
        "Die Stimmungserfassung ist ein wichtiger Bestandteil der Depressionsdiagnostik und -behandlung und kann Hinweise auf die Stimmung des Patienten geben."
}

const VALUE_TYPE_STEPS_DOC: DocumentationElement = {
    title: "Schrittzahl",
    content:
        "Die Schrittzahl erfasst, wie viele Schritte eine Person pro Tag geht. Sie ist ein Indikator für körperliche Aktivität. Studien zeigen, dass körperliche Aktivität positive Auswirkungen auf die Stimmung und die psychische Gesundheit hat."
}

const VALUE_TYPE_SLEEP_DURATION_DOC: DocumentationElement = {
    title: "Schlafdauer",
    content:
        "Die Schlafdauer gibt an, wie viele Stunden eine Person pro Nacht schläft. Schlafstörungen, einschließlich Veränderungen der Schlafdauer, sind ein häufiges Symptom von Depressionen. Sowohl zu wenig als auch zu viel Schlaf kann sich negativ auf die Stimmung und den Krankheitsverlauf auswirken."
}

const VALUE_TYPE_SLEEP_LATENCY_DOC: DocumentationElement = {
    title: "Einschlafdauer",
    content:
        "Die Einschlafdauer gibt an, wie lange eine Person braucht, um einzuschlafen. Schwierigkeiten beim Einschlafen (verlängerte Einschlafdauer) sind ein häufiges Symptom von Depressionen."
}

const VALUE_TYPE_SLEEP_HEART_RATE_DOC: DocumentationElement = {
    title: "Durchschnittliche nächtliche Herzfrequenz",
    content:
        "Die Herzfrequenz gibt an, wie oft das Herz pro Minute schlägt. Sie ist ein wichtiger kardialer Parameter, der bei Depressionen von Bedeutung sein kann. Studien zeigen, dass Menschen mit Depressionen im Vergleich zu Menschen ohne Depression häufig eine erhöhte Herzfrequenz im Ruhezustand aufweisen."
}

const VALUE_TYPE_SLEEP_HEART_RATE_VARIABILITY_DOC: DocumentationElement = {
    title: "Durchschnittliche nächtliche Herzfrequenzvariabilität",
    content:
        "Die Herzfrequenzvariabilität (HRV) misst die zeitlichen Abstände zwischen den einzelnen Herzschlägen. Eine hohe HRV wird mit einer guten Stressregulation und einer gesunden psychischen Verfassung in Verbindung gebracht. Menschen mit Depressionen weisen häufig eine reduzierte HRV auf."
}

export const ValueTypeDocumentations: DocumentationElement[] = [
    VALUE_TYPE_PHQ_DOC,
    VALUE_TYPE_SFQ_DOC,
    VALUE_TYPE_MOOD_DOC,
    VALUE_TYPE_STEPS_DOC,
    VALUE_TYPE_SLEEP_DURATION_DOC,
    VALUE_TYPE_SLEEP_LATENCY_DOC,
    VALUE_TYPE_SLEEP_HEART_RATE_DOC,
    VALUE_TYPE_SLEEP_HEART_RATE_VARIABILITY_DOC
]

function ValueTypeDocumentation(type: ValueType): DocumentationElement {
    switch (type) {
        case ValueType.PHQUESTIONNAIRE:
            return VALUE_TYPE_PHQ_DOC
        case ValueType.SFQUESTIONNAIRE:
            return VALUE_TYPE_SFQ_DOC
        case ValueType.MOOD:
            return VALUE_TYPE_MOOD_DOC
        case ValueType.STEPS:
            return VALUE_TYPE_STEPS_DOC
        case ValueType.SLEEP_DURATION:
            return VALUE_TYPE_SLEEP_DURATION_DOC
        case ValueType.SLEEP_LATENCY:
            return VALUE_TYPE_SLEEP_LATENCY_DOC
        case ValueType.SLEEP_HEART_RATE:
            return VALUE_TYPE_SLEEP_HEART_RATE_DOC
        case ValueType.SLEEP_HEART_RATE_VARIABILITY:
            return VALUE_TYPE_SLEEP_HEART_RATE_VARIABILITY_DOC
    }
}

export default ValueTypeDocumentation
